var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.855 178.068C118.92 169.464 113.895 162.306 109.638 156.242C102.08 145.477 96.9416 138.157 93.4253 132.31C90.7348 127.837 89.1674 124.493 88.2421 121.369C87.3273 118.28 86.975 115.184 86.975 111.125C86.975 89.8482 104.223 72.6 125.5 72.6C146.777 72.6 164.025 89.8482 164.025 111.125C164.025 115.184 163.673 118.28 162.758 121.369C161.833 124.493 160.265 127.837 157.575 132.31C154.058 138.157 148.92 145.477 141.362 156.242C137.106 162.305 132.082 169.461 126.149 178.063C125.836 178.513 125.162 178.512 124.85 178.062L121.069 180.679L124.855 178.068Z",
    stroke: "white",
    strokeWidth: 9.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 115,
    fill: "white",
    transform: "translate(68 68)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/Pickup.b3d71047ea5bcebb193e432ec3c38f13.svg";
export { ForwardRef as ReactComponent };